import React from 'react';
import css from './table-vertical-size-fixer.module.css';

interface Props {
  children?: React.ReactElement;
}

export default function TableVerticalSizeFixer({ children }: Props) {
  return <div className={css['size-fixer']}>{children}</div>;
}
